import * as React from 'react';
import { Button as CNButton } from '@shadcn/components/ui/button';
import { cn } from '@shadcn/lib/utils';

interface ButtonProps extends React.ComponentProps<typeof CNButton> {
  fullWidth?: boolean;
}

export default function Button({ className, children, fullWidth = false, ...props }: ButtonProps) {
  const fullWidthClass = fullWidth ? 'w-full' : 'w-fit';
  const customizationClassNames =
    'flex px-2.5 py-2 justify-center items-center gap-1.5 cursor-pointer';

  return (
    <CNButton className={cn(customizationClassNames, fullWidthClass, className)} {...props}>
      {children}
    </CNButton>
  );
}
